<h3 mat-dialog-title>User Admin</h3>
<mat-dialog-content>

    <div class="aip-woptions-sidebar">

        
        <div *ngFor="let row of this.formLayout">

        <div *ngFor="let item of row; let i = index" [style]="getColStyle(i,row.length)">

            <ng-container *ngIf="getType(getItem(item))=='string'">
            <label matLab>{{getItem(item)["label"]?getItem(item)["label"]:getItem(item)["name"]}}</label>
            <input matInput type="text" class="aip-input editable" [(ngModel)]="this.data.data[getItem(item)['name']]" (ngModelChange)="onChange($event)"/>
            <mat-error *ngIf="this.fieldMessage[getItem(item)['name']] != ''">
                {{this.fieldMessage[getItem(item)['name']]}}
            </mat-error>
            </ng-container>

            <ng-container *ngIf="getType(getItem(item))=='readonly'">
                <label matLab>{{getItem(item)["label"]?getItem(item)["label"]:getItem(item)["name"]}}</label>
                <input matInput readonly type="text" class="aip-input readonly" [(ngModel)]="this.data.data[getItem(item)['name']]"/>
            </ng-container>

            <ng-container *ngIf="getType(getItem(item))=='dropdown'">
                <label matLab>{{getItem(item)["label"]?getItem(item)["label"]:getItem(item)["name"]}}</label>
                
                <ng-select class="aip-select editable" appendTo="#selectOverlayDiv" 
                    [items]="this.dropDownItems[getItem(item)['name']]" 
                    [(ngModel)]="this.data.data[getItem(item)['name']]"    
                    bindValue="value"                
                    bindLabel="label"
                    (ngModelChange)="onChange($event)"
                >
                </ng-select>    
                <mat-error *ngIf="this.fieldMessage[getItem(item)['name']] != ''">
                    {{this.fieldMessage[getItem(item)['name']]}}
                </mat-error>

            </ng-container>

            </div>   
            </div>
            
            <div>
                <div class="useraccess-label">User Access</div>
            </div>
    </div>

    
    <div class="access {{this.data.data['usertype']=='Regular'?'':'disabled'}}">    
    <mat-selection-list class="access-list stripe" [multiple]="true" [(ngModel)]="selectedAccess" (selectionChange)="handleChange($event)">
        <ng-container *ngFor="let v of getUserAccessTreeToShow()">
            <mat-list-option [value]="v.id">          
                <div>
                <fa-icon size="lg" matTooltip="Global" *ngIf="v.type=='Global'" class="" icon="globe" class="aip-primary-color"></fa-icon>            
                <fa-icon size="lg" matTooltip="Account" *ngIf="v.type=='Account'" class="" icon="building" class="aip-primary-color"></fa-icon>                        
                <fa-icon size="lg" matTooltip="Region" *ngIf="v.type=='Region'" class="" [icon]="getRegionIcon(v.value)" class="aip-primary-color"></fa-icon>            
                </div>
                
                <fa-icon size="lg" matTooltip="Read/Write Access" *ngIf="v.access=='W'" class="wr-icon" style="color:rgb(99, 255, 71,.9)" icon="edit"></fa-icon>            
                <fa-icon size="lg" matTooltip="Read Access" *ngIf="v.access=='R'" class="wr-icon" style="color:rgb(247, 207, 43,.9)" icon="book-open"></fa-icon>
                <fa-icon size="lg" matTooltip="No Access" *ngIf="v.access=='N'" class="wr-icon" style="color:rgb(255, 99, 71,.9)" icon="ban"></fa-icon>
    
                <span class="list-name">{{v["valuelabel"]}}</span>
              
            </mat-list-option>
            <ng-container *ngIf="v.type === 'Region'">
                <mat-list-option *ngFor="let sub of v.subregions" [value]="sub.id" class="custom-sub-list-option">          
                    <div>
                        <fa-icon size="lg" matTooltip="Region" class="" [icon]="getRegionIcon(sub.value)" class="aip-primary-color"></fa-icon>            
                    </div>
                    
                    <fa-icon size="lg" matTooltip="Read/Write Access" *ngIf="sub.access=='W'" class="wr-icon" style="color:rgb(99, 255, 71,.9)" icon="edit"></fa-icon>            
                    <fa-icon size="lg" matTooltip="Read Access" *ngIf="sub.access=='R'" class="wr-icon" style="color:rgb(247, 207, 43,.9)" icon="book-open"></fa-icon>
                    <fa-icon size="lg" matTooltip="No Access" *ngIf="sub.access=='N'" class="wr-icon" style="color:rgb(255, 99, 71,.9)" icon="ban"></fa-icon>
        
                    <span class="list-name">{{sub["subvalue"]}}</span>
                  
                </mat-list-option>
            </ng-container>
        </ng-container>
    </mat-selection-list>
    <div class="access-buttons">

        <button mat-raised-button [matMenuTriggerFor]="menuGlobalAdd" class="aip-button-alt ua-button">Global</button>
        <mat-menu #menuGlobalAdd="matMenu">
          <button class="aip-button-alt" mat-menu-item (click)="addGlobal('R')">Add Read Entry</button>
          <button class="aip-button-alt" mat-menu-item (click)="addGlobal('W')">Add Read/Write Entry</button>
        </mat-menu>

        <button mat-raised-button [matMenuTriggerFor]="menuRegionAdd" class="aip-button-alt ua-button">Region</button>
        <mat-menu #menuRegionAdd="matMenu">
          <button class="aip-button-alt" mat-menu-item (click)="addRegion('R')">Add Read Entry</button>
          <button class="aip-button-alt" mat-menu-item (click)="addRegion('W')">Add Read/Write Entry</button>          
          <button class="aip-button-alt" mat-menu-item (click)="addRegion('N')">Add No Access Entry</button>          
        </mat-menu>        

        <button mat-raised-button [matMenuTriggerFor]="menuAccountAdd" class="aip-button-alt ua-button">Account</button>
        <mat-menu #menuAccountAdd="matMenu">
          <button class="aip-button-alt" mat-menu-item (click)="addUserAccess('R')">Add Read Entry</button>
          <button class="aip-button-alt" mat-menu-item (click)="addUserAccess('W')">Add Read/Write Entry</button>
          <button class="aip-button-alt" mat-menu-item (click)="addUserAccess('N')">Add No Access Entry</button>
        </mat-menu>        
        
        <button [disabled]="!selectedAccess || selectedAccess.length==0" mat-raised-button color="warn" class="aip-button-alt ua-button" (click)="remove()">Remove</button>
        <button [disabled]="!selectedAccess || selectedAccess.length==0" mat-raised-button [matMenuTriggerFor]="menuChange" class="aip-button-alt ua-button">Change</button>
        <mat-menu #menuChange="matMenu">
          <button class="aip-button-alt" mat-menu-item (click)="change('R')">Read</button>
          <button class="aip-button-alt" mat-menu-item (click)="change('W')">Read/Write</button>
          <button class="aip-button-alt" mat-menu-item (click)="change('N')">No Access</button>
        </mat-menu>        
        
    </div>
    </div>





</mat-dialog-content>
<mat-dialog-actions align="end">
    <button [disabled]="!allowSave" mat-raised-button color="primary" class="aip-button" (click)="save()" [mat-dialog-close]="data" cdkFocusInitial>OK</button>    
    <button *ngIf="data.data['id']!=undefined" mat-raised-button color="warn" class="aip-button" (click)="delete()">Delete</button>
    <button mat-raised-button class="aip-button-alt" (click)="close()">Cancel</button>
</mat-dialog-actions>


<!-- Overlay for the dropdowns -->
<div id="selectOverlayDiv" #selectOverlay class="aip-select-overlay" style="position: absolute;"></div>